import { Box, Divider, Typography } from '@mui/material'
import AdxButton from 'components/custom/AdxButton'
import AdxCheckbox from 'components/custom/AdxCheckbox'
import AdxFormControlLabel from 'components/custom/AdxFormControlLabel'
import AdxPopper from 'components/reusable/AdxPopper'
import AdxTabsBadge from 'components/reusable/tab/AdxTabsBadge'
import AdxTabsPanel from 'components/reusable/tab/AdxTabsPanel'
import React, { useState } from 'react'
import { useEffect } from 'react'

const SearchFilterPopper = ({ type, setFilter, setApplicationId, resetFilter }) => {
  // checkboxfilters
  let typeFilter
  switch (type) {
    case 'matched':
      // to change value
      typeFilter = [
        { name: 'adnexio', value: 'adnexio' },
        { name: 'External', value: 'external' },
      ]
      // typeFilter = [
      //   { name: 'adnexio (Locked)', value: 'locked' },
      //   { name: 'adnexio (Purchased)', value: 'purchased' },
      //   { name: 'External', value: 'external' },
      // ]
      break
    case 'applied':
      // to change value
      typeFilter = [
        { name: 'adnexio', value: 'adnexio' },
        { name: 'Job board', value: 'job_boards' },
      ]
      // typeFilter = [
      //   { name: 'Locked', value: 'locked' },
      //   { name: 'Purchased', value: 'purchased' },
      // ]
      break
    case 'shortlisted':
    case 'offered':
    case 'hired':
    case 'rejected':
    case 'interview':
      typeFilter = [
        {
          name: 'adnexio',
          applicant_id: '1,2,3,4,5',
          filter: 'adnexio',
        },
        { name: 'Job board', applicant_id: '1,2,3,4,5', filter: 'job_boards' },
        { name: 'External', applicant_id: '1,2,3,4,5', filter: 'external' },
      ]
      // typeFilter = [
      //   {
      //     name: 'Applicant',
      //     applicant_id: '1,2,4,5',
      //   },
      //   { name: 'Matched via adnexio', applicant_id: '3', filter: 'adnexio' },
      //   { name: 'Matched via external', applicant_id: '3', filter: 'external' },
      // ]
      break
  }
  const attachmentFilter = [
    { name: 'Resume', value: 'has-cv' },
    { name: 'Video interview', value: 'has-video' },
  ]
  const interviewFilter = [
    { name: 'Scheduled', value: 'interview-scheduled' },
    { name: 'Completed', value: 'interview-completed' },
    { name: 'Cancelled', value: 'interview-cancelled' },
  ]

  const [typeStates, setTypeStates] = useState(new Array(typeFilter.length).fill(false))
  const [attachmentStates, setAttachmentStates] = useState(
    new Array(attachmentFilter.length).fill(false)
  )
  const [interviewStates, setInterviewStates] = useState(
    new Array(interviewFilter.length).fill(false)
  )
  const [typeTabLabel, setTypeTabLabel] = useState('Type')
  const [attachmentTabLabel, setAttachmentTabLabel] = useState('Attachment')
  const [interviewTabLabel, setInterviewTabLabel] = useState('Interview status')

  // const initialArray = Array.from({ length: typeFilter.length }, (_, index) => index + 1)
  // const [value, setValue] = useState(initialArray)

  const [typeValue, setTypeValue] = useState([])

  // only for status shortlisted,offered,hired,rejected,interview
  const [filterStatesValue, setFilterStatesValue] = useState([])
  const [applicationIdStatesValue, setApplicationIdStatesValue] = useState([])

  const [attachmentValue, setAttachmentValue] = useState([])
  const [interviewValue, setInterviewValue] = useState([])

  const handleTypeAppliedAndMatchedChange = (index, data) => {
    const newTypeStates = [...typeStates]
    newTypeStates[index] = !newTypeStates[index]

    if (newTypeStates[index]) {
      // If the checkbox is checked, add the value to the array
      setTypeValue((prevTypeValue) => [...prevTypeValue, data])
    } else {
      // If the checkbox is unchecked, remove the value from the array
      setTypeValue((prevTypeValue) => prevTypeValue.filter((value) => value !== data))
    }

    setTypeStates(newTypeStates)
  }
  const handleTypeOtherStatusChange = (index, applicant_id, filter) => {
    const newTypeStates = [...typeStates]
    newTypeStates[index] = !newTypeStates[index]

    if (newTypeStates[index]) {
      // If the checkbox is checked, add the value to the array
      setApplicationIdStatesValue((prevTypeValue) => [...prevTypeValue, applicant_id])
      if (filter) {
        setFilterStatesValue((prevTypeValue) => [...prevTypeValue, filter])
      }
    } else {
      // If the checkbox is unchecked, remove the value from the array
      setApplicationIdStatesValue((prevTypeValue) =>
        prevTypeValue.filter((value) => value !== applicant_id)
      )
      setFilterStatesValue((prevTypeValue) => prevTypeValue.filter((value) => value !== filter))
    }

    setTypeStates(newTypeStates)
  }

  const handleAttachmentChange = (index, data) => {
    const newAttachmentStates = [...attachmentStates]
    newAttachmentStates[index] = !newAttachmentStates[index]
    if (newAttachmentStates[index]) {
      // If the checkbox is checked, add the value to the array
      setAttachmentValue((prevTypeValue) => [...prevTypeValue, data])
    } else {
      // If the checkbox is unchecked, remove the value from the array
      setAttachmentValue((prevTypeValue) => prevTypeValue.filter((value) => value !== data))
    }
    setAttachmentStates(newAttachmentStates)
  }
  const handleInterviewChange = (index, data) => {
    const newInterviewStates = [...interviewStates]
    newInterviewStates[index] = !newInterviewStates[index]
    if (newInterviewStates[index]) {
      // If the checkbox is checked, add the value to the array
      setInterviewValue((prevTypeValue) => [...prevTypeValue, data])
    } else {
      // If the checkbox is unchecked, remove the value from the array
      setInterviewValue((prevTypeValue) => prevTypeValue.filter((value) => value !== data))
    }
    setInterviewStates(newInterviewStates)
  }

  // const handleClearFilter = () => {
  //   // Reset filter selections
  //   setTypeStates(new Array(typeFilter.length).fill(false))
  //   setAttachmentStates(new Array(attachmentFilter.length).fill(false))
  //   setInterviewStates(new Array(interviewFilter.length).fill(false))
  // }

  const onDataUpdate = (states) => {
    let filterArray = []
    let applicationIdArray = []
    if (states?.typeValue?.length > 0) {
      const sortedData = states?.typeValue.slice().sort((a, b) => a - b)
      filterArray.push(sortedData.join(','))
    }
    if (states?.filterStatesValue?.length > 0) {
      const sortedData = states?.filterStatesValue.slice().sort((a, b) => a - b)
      filterArray.push(sortedData.join(','))
    }
    // only for type other than matched/applied
    console.log(applicationIdArray)
    if (states?.applicationIdStatesValue?.length > 0) {
      if (states?.applicationIdStatesValue.includes('1,2,3,4,5')) {
        applicationIdArray = ['1,2,3,4,5']
      } else if (states?.applicationIdStatesValue.includes('1')) {
        applicationIdArray = ['1']
      } else {
        applicationIdArray = ['3']
      }
      // if (
      //   states?.applicationIdStatesValue.includes('1,2,4,5') &&
      //   states?.applicationIdStatesValue.includes('3')
      // ) {
      //   applicationIdArray = ['1,2,3,4,5']
      // } else if (states?.applicationIdStatesValue.includes('1,2,4,5')) {
      //   applicationIdArray = ['1,2,4,5']
      // } else {
      //   applicationIdArray = ['3']
      // }
    }
    if (states?.attachmentValue?.length > 0) {
      const sortedData = states?.attachmentValue.slice().sort((a, b) => a - b)
      filterArray.push(sortedData.join(','))
    }
    if (states?.interviewValue?.length > 0) {
      const sortedData = states?.interviewValue.slice().sort((a, b) => a - b)
      filterArray.push(sortedData.join(','))
    }
    setFilter(filterArray.length > 0 ? `&filters=${filterArray.join(',')}` : '')
    setApplicationId(applicationIdArray.length > 0 ? applicationIdArray.join(',') : '')
  }

  const handleDataTransfer = () => {
    const data = {
      typeCheckedStatus: typeStates,
      attachmentCheckedStatus: attachmentStates,
      interviewCheckedStatus: interviewStates,
      typeValue,
      attachmentValue,
      interviewValue,
      filterStatesValue,
      applicationIdStatesValue,
    }
    onDataUpdate(data)
  }

  useEffect(() => {
    // To update tab labels in search filter
    const typeCheckedCount = typeStates.filter((state) => state).length
    const attachmentCheckedCount = attachmentStates.filter((state) => state).length
    const interviewCheckedCount = interviewStates.filter((state) => state).length

    if (typeCheckedCount === 0) {
      setTypeTabLabel(`Type`)
      // resetFilter()
    } else {
      setTypeTabLabel(`Type(${typeCheckedCount})`)
    }
    if (attachmentCheckedCount === 0) {
      setAttachmentTabLabel(`Attachment`)
      // resetFilter()
    } else {
      setAttachmentTabLabel(`Attachment(${attachmentCheckedCount})`)
    }
    if (interviewCheckedCount === 0) {
      setInterviewTabLabel(`Interview status`)
      // resetFilter()
    } else {
      setInterviewTabLabel(`Interview status(${interviewCheckedCount})`)
    }
  }, [typeStates, attachmentStates, interviewStates])

  return (
    <AdxPopper
      buttonIcon="tune"
      sx={{
        // width: `calc((${filterContainerWidth}px ${isSmall ? ' * 2 / 3' : ' * 2 / 5'} ) + 45px)`,
        minWidth: '351px',
        cursor: 'pointer',
      }}
      // childBoxSx={{ m: 0, p: 0 }}
      placement="bottom-start"
      closeOnClick="button"
      iconProps={{ sx: { color: 'alternate.main' } }}
    >
      <Box>
        <Typography
          variant="subtitle1"
          sx={{
            fontWeight: 600,
          }}
          padding="16px 20px 8px"
        >
          Filter
        </Typography>
        <AdxTabsBadge sxTabs={{ color: 'dark-text.main' }} scrollButtons={false}>
          <AdxTabsPanel label={typeTabLabel}>
            <Box
              padding="20px 20px 40px"
              display="flex"
              flexDirection="column"
              borderTop={1}
              borderColor={'gray-line.main'}
            >
              {typeFilter.map((item, index) => (
                <AdxFormControlLabel
                  key={index}
                  label={item.name}
                  control={
                    <AdxCheckbox
                      checked={typeStates[index] || false}
                      onChange={() => {
                        type === 'matched' || type === 'applied'
                          ? handleTypeAppliedAndMatchedChange(index, item.value)
                          : handleTypeOtherStatusChange(index, item.applicant_id, item?.filter)
                      }}
                    />
                  }
                />
              ))}
            </Box>
          </AdxTabsPanel>
          <AdxTabsPanel label={attachmentTabLabel}>
            <Box
              padding="20px 20px 40px"
              display="flex"
              flexDirection="column"
              borderTop={1}
              borderColor={'gray-line.main'}
            >
              {attachmentFilter.map((item, index) => (
                <AdxFormControlLabel
                  key={index}
                  label={item.name}
                  control={
                    <AdxCheckbox
                      checked={attachmentStates[index] || false}
                      onChange={() => handleAttachmentChange(index, item.value)}
                    />
                  }
                />
              ))}
            </Box>
          </AdxTabsPanel>
          {type === 'interview' && (
            <AdxTabsPanel label={interviewTabLabel}>
              <Box
                padding="20px 20px 40px"
                display="flex"
                flexDirection="column"
                borderTop={1}
                borderColor={'gray-line.main'}
              >
                {interviewFilter.map((item, index) => (
                  <AdxFormControlLabel
                    key={index}
                    label={item.name}
                    control={
                      <AdxCheckbox
                        checked={interviewStates[index] || false}
                        onChange={() => handleInterviewChange(index, item.value)}
                      />
                    }
                  />
                ))}
              </Box>
            </AdxTabsPanel>
          )}
        </AdxTabsBadge>
        <Divider />
        <Box
          padding={'20px'}
          display="flex"
          flexDirection="row"
          justifyContent="end"
          alignItems="center"
          gap={'10px'}
        >
          <AdxButton
            variant={'outlined'}
            sx={{ padding: '12px 14px', width: '100px' }}
            size="small"
          >
            Cancel
          </AdxButton>
          <AdxButton
            variant={'contained'}
            sx={{ padding: '12px 14px', width: '136px' }}
            size="small"
            onClick={handleDataTransfer}
          >
            Apply filter
          </AdxButton>
        </Box>
      </Box>
    </AdxPopper>
  )
}

export default SearchFilterPopper
